import { Row, Col } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";

import i18n from "i18next";
import {
  FooterSection,
  Title,
  NavLink,
  Extra,
  LogoContainer,
  Para,
  Large,
  Chat,
  Empty,
  FooterContainer,
  Language,
  Label,
  LanguageSwitch,
  LanguageSwitchContainer,
} from "./styles";

interface SocialLinkProps {
  href: string;
  src: string;
}

const Footer = ({ t }: { t: TFunction }) => {
  const handleChange = (language: string) => {
    i18n.changeLanguage(language);
  };

  const SocialLink = ({ href, src }: SocialLinkProps) => {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        key={src}
        aria-label={src}
      >
        <SvgIcon src={src} width="25px" height="25px" />
      </a>
    );
  };

  return (
    <>
      <FooterSection>
        <Container>
          <Row justify="space-between">
            <Col lg={8} md={8} sm={12} xs={24}>
              <Language>Usługi</Language>
              <Large to="/transport">Księgowość dla transportu</Large>
              <Large to="/transport">Minimalizacja podatku transportowego</Large>
              <Large to="/spolki">Zakładanie spółek</Large>
              <Large to="/spolki">Estoński CIT</Large>
              <Large to="/spolki">Fundacja rodzinna</Large>
            </Col>
            <Col lg={8} md={8} sm={12} xs={24}>
              <Title>Firma</Title>
              <Large to="/o-nas">O nas</Large>
              <Large to="/kontakt">Kontakt</Large>
              <Large to="/">Polityka prywatności</Large>
            </Col>
            <Col lg={8} md={8} sm={12} xs={24}>
              <Title>Kontakt</Title>
              <Para>Email: kontakt@example.pl</Para>
              <Para>Tel: +48 XXX XXX XXX</Para>
              <Para>Adres: [Do uzupełnienia]</Para>
              <Para>NIP: XXXXXXXXXX</Para>
              <Para>REGON: XXXXXXXXX</Para>
            </Col>
          </Row>
        </Container>
      </FooterSection>
      <Extra>
        <Container border={true}>
          <Row
            justify="space-between"
            align="middle"
            style={{ paddingTop: "3rem" }}
          >
            <NavLink to="/">
              <LogoContainer>
                <img
                  src="/img/logo.png"
                  alt="homepage"
                  width="101px"
                  height="64px"
                />
              </LogoContainer>
            </NavLink>
            <FooterContainer>
            </FooterContainer>
          </Row>
        </Container>
      </Extra>
    </>
  );
};

export default withTranslation()(Footer);
